import React, { useState, useEffect } from "react";
import "animate.css";
import { Row, Col } from "antd";
import { Link as LinkSection, Element, Events, scrollSpy } from "react-scroll";

import { httpClient } from "core/util/httpClient";
import { leaveConditions } from "core/schemas";

import ScrollUpBtn from "components/ScrollUpBtn";
import ListImage from "components/ListImage";
import NumberImage from "components/NumberImage";

import downloadIcon from "assets/images/svg/icon-file-download.svg";

import {
  Container,
  Title,
  ContainerCooper,
  TextSection,
  TextHead,
  CardImage,
  ContainerCard,
  NumberList,
  Text,
  TextNote,
} from "./leaveCondition.style";

const LeaveCondition = () => {
  const [leaveData, setLeaveData] = useState({});

  useEffect(() => {
    Events.scrollEvent.register("begin", function (to, element) {
      // console.log('begin', arguments)
    });

    Events.scrollEvent.register("end", function (to, element) {
      // console.log('end', arguments)
    });

    scrollSpy.update();

    return () => {
      Events.scrollEvent.remove("begin");
      Events.scrollEvent.remove("end");
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    getDataCooper();
  }, []);

  const getDataCooper = async () => {
    const response = await httpClient.get(leaveConditions);

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setLeaveData(data?.section);
    } else {
      setLeaveData({});
    }
  };

  const renderLink = (to, name) => {
    return (
      <LinkSection
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <TextSection>{name}</TextSection>
      </LinkSection>
    );
  };

  const listColor = {
    ลาระหว่างเรียน: "#FFF9EA",
    ลาช่วงสอบ: "#FFF",
    ลาพักเรียน: "#FFF9EA",
    ลาออก: "#FFF",
  };

  const renderNumberList = (item) => {
    return (
      <>
        <TextHead>{item?.title}</TextHead>

        {item?.conent_0 && (
          <NumberList>
            <NumberImage number={1} position={0} />
        <div style={{ display: "grid" }}>

            {item?.title === "ลาออก" ? "เขียนคำร้อง ท.96":item?.conent_0}
            <a
              href={
                item?.title === "ลาออก"
                  ? "http://sutgateway.sut.ac.th/ces/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2/download-%e0%b8%84%e0%b8%b3%e0%b8%a3%e0%b8%ad%e0%b8%87/"
                  : item?.link
              }
              target="_blank"
              rel="noreferrer"
              download
            >
              <img
                loading="lazy"
                src={downloadIcon}
                alt="icon download file"
                style={{ marginRight: "20px", height: "32px" }}
              />
              <span>
                {item?.title === "ลาออก"
                  ? "เลือกดาวน์โหลดแบบฟอร์ม ท.96"
                  : "ดาวน์โหลดแบบฟอร์ม"}
              </span>
            </a>
            </div>

          </NumberList>
        )}

        {item?.conent_1 && (
          <NumberList>
            <NumberImage number={2} position={45} />
            {item?.title === "ลาออก" ? (
              <span>
                นำคำร้องเข้าพบผู้พิจารณาอนุมัติ ตามลำดับดังนี้ <br />
                <span style={{ marginLeft: "35px"}}>1 อาจารย์ที่ปรึกษา เพื่อขอความเห็นชอบ</span> <br />
                <span style={{ marginLeft: "35px"}}>2 เจ้าหน้าที่สาขา/สำนักวิชา</span>
                เพื่อเสนอคณบดีสำนักวิชาที่นักศึกษาสังกัด เพื่อพิจารณาอนุมัติ <br />
                <p style={{ marginTop: "14px"}}>
                หากเป็นนักศึกษา ป.ตรี ในสังกัดสำนักวิชาเทคโนโลยีสังคม
                ให้เสนอหัวหน้าสาขาวิชา เพื่อความเห็นชอบด้วยก่อนเสนอคณบดี
                </p>

              </span>
            ) : (
              item?.conent_1
            )}
          </NumberList>
        )}

        {item?.conent_2 && (
          <NumberList>
            <NumberImage number={3} position={90} />
            {item?.conent_2}
          </NumberList>
        )}

        {item?.conent_3 && (
          <NumberList>
            <NumberImage number={4} position={180} />
            {item?.conent_3}
          </NumberList>
        )}

        {item?.conent_4 && item?.title !== "ลาออก" && (
          <NumberList>
            <NumberImage number={5} position={180} />
            {item?.conent_4}
          </NumberList>
        )}
      </>
    );
  };

  const renderNumberList1 = (item) => {
    return (
      <>
        <TextHead>{item?.title}</TextHead>

        {item?.conent_0 && (
          <NumberList>
            <NumberImage number={1} position={0} />
        <div style={{ display: "grid" }}>

            {item?.conent_0}
            <a
              href={
                item?.title === "ลาช่วงสอบ"
                  ? "http://sutgateway.sut.ac.th/ces/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2/download-%e0%b8%84%e0%b8%b3%e0%b8%a3%e0%b8%ad%e0%b8%87/"
                  : item?.link
              }
              target="_blank"
              rel="noreferrer"
              download
            >
              <img
                loading="lazy"
                src={downloadIcon}
                alt="icon download file"
                style={{ marginRight: "20px", height: "32px" }}
              />
              <span>
                {item?.title === "ลาช่วงสอบ"
                  ? "เลือกดาวน์โหลดแบบฟอร์ม ท.95/1"
                  : "ดาวน์โหลดแบบฟอร์ม"}
              </span>
            </a>
            </div>
          </NumberList>
        )}

        {item?.conent_1 && (
          <NumberList>
            <NumberImage number={2} position={45} />
            {item?.conent_1}
          </NumberList>
        )}

        {item?.conent_2 && (
          <NumberList>
            <NumberImage number={3} position={90} />
            {item?.conent_2}
          </NumberList>
        )}

        {item?.conent_3 && (
          <NumberList>
            <NumberImage number={4} position={180} />
            {item?.title === "ลาช่วงสอบ" ? (
              <span>
                ทำสำเนาเก็บไว้ให้อาจารย์ผู้สอน เพื่อกำหนดวัน/เวลา/สถานที่สอบ
                ในช่องความเห็นของอาจารย์ผู้สอน
                และให้นักศึกษาเก็บตัวจริงไว้เป็นหลักฐาน
                <span style={{ color: "#EC6547" }}>
                  {" "}
                  โดยไม่ต้องนำส่งฝ่ายทะเบียนนักศึกษา
                </span>
              </span>
            ) : (
              item?.conent_3
            )}
          </NumberList>
        )}
      </>
    );
  };

  const renderNumberList2 = (item) => {
    return (
      <>
        <TextHead>{item?.title}</TextHead>

        {item?.conent_0 && (
          <NumberList>
            <NumberImage number={1} position={0} />
            <div style={{ display: "grid" }}>
            {item?.conent_0}
            <a
              href={
                item?.title === "ลาระหว่างเรียน"
                  ? "http://sutgateway.sut.ac.th/ces/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2/download-%e0%b8%84%e0%b8%b3%e0%b8%a3%e0%b8%ad%e0%b8%87/"
                  : item?.title === "ลาพักเรียน"
                  ? "http://sutgateway.sut.ac.th/ces/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2/download-%e0%b8%84%e0%b8%b3%e0%b8%a3%e0%b8%ad%e0%b8%87/"
                  : item?.link
              }
              target="_blank"
              rel="noreferrer"
              download
            >
              <img
                loading="lazy"
                src={downloadIcon}
                alt="icon download file"
                style={{ marginRight: "20px", height: "32px" }}
              />
              <span>
                {item?.title === "ลาระหว่างเรียน"
                  ? "เลือกดาวน์โหลดแบบฟอร์ม ท.95"
                  : item?.title === "ลาพักเรียน"
                  ? "เลือกดาวน์โหลดแบบฟอร์ม ท.97"
                  : "ดาวน์โหลดแบบฟอร์ม"}
              </span>
            </a>
            </div>
          </NumberList>
        )}

        {item?.conent_1 && (
          <NumberList>
            <NumberImage number={2} position={45} />
            {item?.title === "ลาพักเรียน" ? (
              <div className="link-web leave-of-study">
                ส่งคำร้องฯ พร้อมระบุเหตุผลและแนบเอกสารประกอบ (ถ้ามี)
                ต่อเจ้าหน้าที่ สาขาวิชา/สำนักวิชา เพื่อเสนอผู้มีอำนาจพิจารณา
                <a
                  href="http://sutgateway.sut.ac.th/ces/stepform2/20_2_T_E.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  <u>ดูข้อมูลผู้มีอำนาจพิจารณา</u>
                </a>
              </div>
            ) : (
              item?.conent_1
            )}
          </NumberList>
        )}

        {item?.conent_2 && (
          <NumberList>
            <NumberImage number={3} position={90} />
            {item?.conent_2}
          </NumberList>
        )}
        {item?.conent_3 && (
          <NumberList>
            <NumberImage number={4} position={180} />
            {item?.title === "ลาระหว่างเรียน" ? (
              <span>
                ทำสำเนาเก็บไว้ให้อาจารย์ผู้สอน
                และให้นักศึกษาเก็บตัวจริงไว้เป็นหลักฐาน{" "}
                <span style={{ color: "#EC6547" }}>
                  โดยไม่ต้องนำส่งฝ่ายทะเบียนนักศึกษา
                </span>
              </span>
            ) : (
              item?.conent_3
            )}
          </NumberList>
        )}
      </>
    );
  };
  const renderNumberList2h = (item) => {
    return (
      <>
        {item?.conent_4 && (
          <NumberList>
            <NumberImage number={5} position={90} />
            {item?.conent_4}
          </NumberList>
        )}

        {item?.conent_5 && (
          <NumberList>
            <NumberImage number={6} position={180} />
            {item?.conent_5}
          </NumberList>
        )}

        {/* {item?.conent_6 && (
          <NumberList>
            <NumberImage number={7} position={90} />
            {item?.conent_6}
          </NumberList>
        )} */}
      </>
    );
  };

  return (
    <>
      <Container>
        <Row>
          <Col span={24} className="row-title">
            <Title className="animate__animated animate__flipInX animate__slow">
              เงื่อนไขการลา
            </Title>
          </Col>
        </Row>
        <Row className="row-section">
          {leaveData.length >= 0 &&
            leaveData.map((item, index) => {
              return (
                <Col key={index} span={6}>
                  {renderLink(item.title, item.title)}
                </Col>
              );
            })}
        </Row>

        {leaveData.length >= 0 &&
          leaveData.map((item, index) => {
            return (
              <Element name={item?.title} key={index}>
                <ContainerCooper bg={listColor[item?.title]}>
                  <Row gutter={[24, 24]}>
                    {item?.title === "ลาระหว่างเรียน" ||
                    item?.title === "ลาพักเรียน" ? (
                      <>
                        <Col span={8}>
                          <ContainerCard>
                            <CardImage>
                              <img
                                src={item?.media}
                                alt="leave condition"
                                loading="lazy"
                              />
                            </CardImage>
                          </ContainerCard>
                          {item?.title === "ลาพักเรียน" && item?.conent_6 && (
                            <ListImage noteText={item?.conent_6} type="note" />
                          )}
                        </Col>
                        {item?.title === "ลาระหว่างเรียน" && (
                          <>
                            <Col span={15} offset={1}>
                              {renderNumberList2(item)}
                            </Col>

                            {item?.conent_3 && (
                              <ListImage
                                noteText={item?.conent_4}
                                type="note"
                              />
                            )}
                          </>
                        )}
                        {item?.title === "ลาพักเรียน" && (
                          <>
                            <Col span={15} offset={1}>
                              {renderNumberList2(item)}

                              {/* <Text>{item?.conent_3}</Text> */}
                              {renderNumberList2h(item)}
                            </Col>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {item?.title === "ลาช่วงสอบ" ? (
                          <>
                            <Col span={15} className="col-leave">
                              {renderNumberList1(item)}
                            </Col>

                            <Col span={8} offset={1}>
                              <ContainerCard>
                                <CardImage>
                                  <img
                                    loading="lazy"
                                    src={item?.media}
                                    alt="leave condition"
                                  />
                                </CardImage>
                              </ContainerCard>
                            </Col>

                            {item?.conent_4 && (
                              <ListImage
                                noteText={item?.conent_4}
                                type="note"
                              />
                            )}
                          </>
                        ) : (
                          <>
                            <Col span={15} className="col-leave">
                              {renderNumberList(item)}
                            </Col>

                            <Col span={8} offset={1}>
                              <ContainerCard>
                                <CardImage>
                                  <img
                                    loading="lazy"
                                    src={item?.media}
                                    alt="leave condition"
                                  />
                                </CardImage>
                              </ContainerCard>
                              {item?.title === "ลาออก" && item?.conent_4 && (
                                <>
                                  <ListImage
                                    noteText={item?.conent_4}
                                    type="note"
                                  />

                                  {item?.conent_5 && (
                                    <ListImage
                                      noteText={item?.conent_5}
                                      type="note"
                                      icon="no"
                                    />
                                  )}
                                </>
                              )}
                            </Col>
                          </>
                        )}
                      </>
                    )}
                  </Row>
                </ContainerCooper>
              </Element>
            );
          })}
      </Container>

      <ScrollUpBtn />
    </>
  );
};

export default LeaveCondition;
